import { render, staticRenderFns } from "./PalmKingDashboard.vue?vue&type=template&id=b0e0c6f4"
import script from "./PalmKingDashboard.vue?vue&type=script&lang=ts"
export * from "./PalmKingDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports